<div class="dialogMainDiv">
    <p class="subHeadingInSettings">Add Directory</p>
    <table>
        <tbody>
            <tr>
                <td>
                    <p class="passwordText">Directory Name</p>
                </td>
                <td>
                    <input class="mainTextbox" placeholder="Queue Name" [(ngModel)]="data.directoryName">
                </td>
            </tr>
            <tr>
                <td>
                    <p class="passwordText">S3 Data Bucket</p>
                </td>
                <td>
                    <input class="mainTextbox" placeholder="S3 Input Bucket" [(ngModel)]="data.dataBucket">
                </td>
            </tr>
            <tr>
                <td>
                    <p class="passwordText">Direcotry in Bucket</p>
                </td>
                <td>
                    <input class="mainTextbox" placeholder="Direcotry" [(ngModel)]="data.directory">
                </td>
            </tr>
        </tbody>
    </table>
    <br>
    <button class="blueButton" (click)="closeDialog()" >Cancel</button>
    <button class="blueButton" [mat-dialog-close]="data" >Add Directory</button>
</div>